import { eventType, pingInterval } from 'constants/analytics';
import { useTracking } from 'hooks';
import React, { useState } from 'react';
import useInterval from 'react-use/lib/useInterval';
import { ContentTypeEnum } from 'types/types';
const IntegrationAnalyticsContext = React.createContext(null);
const IntegrationAnalyticsConsumer = IntegrationAnalyticsContext.Consumer;
const IntegrationAnalyticsProvider = ({ children, productId, preview = false, gaTrackingId = '', }) => {
    const [trackingAllowed, setStatisticsAccepted] = useState(false);
    const { analytics, trackSteps, visitorId, sessionActive, sessionId } = useTracking({
        productId,
        trackingAllowed,
        preview,
        byQr: '',
        gaTrackingId,
    });
    const interval = sessionActive ? pingInterval : null;
    const pingTracking = () => {
        // only track if tracking is allowed
        if (!trackingAllowed)
            return;
        console.info('host', window.location.host, window.location);
        analytics.track(eventType.ping, {
            visitorId,
            productId,
            sessionId,
            contentType: ContentTypeEnum.PRODUCT_JOURNEY_BLOCK,
            interval,
        });
    };
    useInterval(pingTracking, sessionActive ? pingInterval : null);
    return (React.createElement(IntegrationAnalyticsContext.Provider, { value: { analytics, trackSteps, setStatisticsAccepted } }, children));
};
export { IntegrationAnalyticsConsumer, IntegrationAnalyticsProvider };
export default IntegrationAnalyticsContext;
